import { render } from "./AppInput.vue?vue&type=template&id=131aa0d4&scoped=true&ts=true"
import script from "./AppInput.vue?vue&type=script&lang=ts"
export * from "./AppInput.vue?vue&type=script&lang=ts"

import "./AppInput.vue?vue&type=style&index=0&id=131aa0d4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131aa0d4"]])

export default __exports__